import { UIPAGE } from "@/constants/ui-page.constants";
import { RouteInfo } from "../types";
import { authGuard, permissionGuard } from "../guards/index";

const ChangeOfAddress2ndPhase = () =>
	import(
		/* webpackChunkName: "chunk-customer-product-change-of-address-2nd-phase" */ "@/views/customer/product-change-of-address/2nd-phase/ChangeOfAddress2ndPhase.vue"
	);

const PromotionsStep = () =>
	import(
		/* webpackChunkName: "chunk-customer-product-change-of-address-2nd-phase-promotions" */ "@/views/customer/product-change-of-address/2nd-phase/components/PromotionsStep.vue"
	);

const ConfigurationStep = () =>
	import(
		/* webpackChunkName: "chunk-customer-product-change-of-address-2nd-phase-configuration" */ "@/views/customer/product-change-of-address/2nd-phase/components/ConfigurationStep.vue"
	);

const OrderStep = () =>
	import(
		/* webpackChunkName: "chunk-customer-product-change-of-address-2nd-phase-order" */ "@/views/customer/product-change-of-address/2nd-phase/components/OrderStep.vue"
	);

export const CustomerProductChangeOfAddress2ndPhaseRoute: RouteInfo = {
	id: UIPAGE.CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE,
	path: "/customers/:customerId/products/:productId/continue-change-of-address",
	component: ChangeOfAddress2ndPhase,
	guards: [authGuard, permissionGuard],
	props: (route) => ({
		customerId: route.query.customerId,
		productId: route.query.productId
	}),
	children: [
		{
			id: UIPAGE.CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROMOTIONS,
			path: ":processId/promotions",
			component: PromotionsStep,
			title: "customers.products.change_of_address.display"
		},
		{
			id: UIPAGE.CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_CONFIGURATION,
			path: ":processId/configuration",
			component: ConfigurationStep,
			title: "customers.products.change_of_address.display"
		},
		{
			id: UIPAGE.CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_ORDER,
			path: ":processId/order",
			component: OrderStep,
			title: "customers.products.change_of_address.display"
		}
	]
};
